import React from "react";
// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import WaitDialog from '../../../widgets/WaitDialog';

import GetCorsi from '../../../services/getCorsi';
import getStudenti from '../../../services/getStudentiForBilling';
import getPianoPagamentiCorso from '../../../services/getPianoPagamentiCorso';
import GestioneRate from "../../../widgets/GestioneRateWidget";
import getPianoPagamentiCorsoStudenti from "../../../services/getPianoPagamentiCorsoStudenti";
import addPianoPagamentiCorsoStudenti from "../../../services/addPianoPagamentiCorsoStudenti";
import deleteRateStatus from "../../../services/deleteRateStatus";
import addRataStatus from "../../../services/addRataStatus";
import getRataStatus from "../../../services/getRataStatus";
import { Prompt } from 'react-router';
import { NineCellLoading } from 'react-loadingg';
import translateString from "../../../utils/Locales";
import Utils from "../../../utils/utils";
import emettiRicevuta from "../../../services/emettiRicevutaDaRata";

let t = translateString;

export default class EditCorso extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.selectRef = React.createRef();

    this.state = {
      unsavedChanges: false, 
      isLoading: true
    }


  }

  async reload(){
    this.setState({ isLoading: true });
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentCourse = cookies.get('currentCourse', { path: '/' });
    const currentStudente = cookies.get('currentStudent', { path: '/' });
    
    this.corsi = await GetCorsi(username, token);
    this.corso = this.corsi.find(c => c.id == currentCourse);
    this.studenti = await getStudenti(username, token);
    this.studente = this.studenti.find(s => s.id == currentStudente);
    this.studenti = this.studenti.filter(s => s.corsi.indexOf(currentCourse+";") != -1);

    this.pianoRateCorso = await getPianoPagamentiCorso(username, token, this.corso.id);
    this.pianoRateCorsoStudente = await getPianoPagamentiCorsoStudenti(username, token, this.corso.id, this.studente.id);

    this.rataStatus = await getRataStatus(username, token, this.corso.id, this.studente.id);

    this.setState({
      costo: "0", 
      isLoading: false,
    });
  }

  async componentDidMount(){
    await this.reload();

    window.addEventListener('beforeunload', (e) => this.handleUnload(e));
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', (e) => this.handleUnload(e));
  }

  handleUnload(event) {
      if (this.state.unsavedChanges) {
        event.preventDefault();
        event.returnValue = "";
        return "";
      }
  }

  render () {

    this.searchCols = ['nome', 'cognome', 'mail'];

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    if (this.corso == undefined) return <div></div>;
    
    this.custom = this.pianoRateCorsoStudente != undefined && this.pianoRateCorsoStudente != null;

    return (
      <>
      <Prompt
        when={this.state.unsavedChanges}
        message={t('modifiche_n_salvate')}
      />
      <div id={Math.random()}>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('piano_rateale') + " " + this.studente.nome + ' ' + this.studente.cognome}/>

        <div style={container}>
          <div style={{ marginLeft: 20 }}>{this.corso.name}</div>
          <div style={{ marginLeft: 20 }}>{this.studente.nome + ' ' + this.studente.cognome}</div>
        </div>

        <GestioneRate piano={this.pianoRateCorsoStudente != undefined ? this.pianoRateCorsoStudente : this.pianoRateCorso} 
              custom={this.custom} 
              isStudent={true}
              onOpen={() => { }}
              studentObj={this.studente}
              corso={this.corso}
              onModification={() => {
                this.setState({unsavedChanges: true});
              }}
              onSalva={async (costo, rate, rataStatus) => {
                var json ={
                  costo: costo, 
                  rate: rate
                };

                if (this.custom == false){
                  if (window.confirm(t('a_piano_custom')) == false) return;
                }
                
                const cookies = new Cookies();
                const username = cookies.get('username', { path: '/' });
                const token = cookies.get('token', { path: '/' });
                await addPianoPagamentiCorsoStudenti(username, token, this.corso.id, this.studente.id, JSON.stringify(json));

                await deleteRateStatus(username, token, this.corso.id, this.studente.id);
                for (var rata of rataStatus) {
                  let res = await addRataStatus(username, token, rata.id_corso, rata.id_studente, rata.data, parseInt(rata.importo), rata.status, rata.files, rata.note, rata.data_pagamento ? rata.data_pagamento : '', rata.metodo ? rata.metodo : '', rata.inviata_sdi ? rata.inviata_sdi : 0, rata.uuid_sdi ? rata.uuid_sdi : '', rata.n_fattura ? rata.n_fattura : '');
                }

                this.custom = true;
                this.setState({unsavedChanges: false});
                Utils.showSuccess(t('salvataggio_fatto'));
                setTimeout(() => {
                  window.location.reload();
                }, 500);
        }} />

        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>
        </LoadingOverlay>
      </div>
      </>
    );
  }
}

const container = {
  borderRadius: '10px',
  boxShadow: '0px 2px 10px lightgrey', 
  paddingTop: 10, 
  paddingBottom: 10, 
  backgroundColor: 'white',
  padding: '10px',
  marginBottom: '10px', 
  ontWeight: 'bold'
}

